<template>
  <div class="page-container Main-section">
    <v-app>
      <v-app-bar
        height="48"
        clipped-left
        color="primary"
        class="custom-bar elevation-2"
        dark
        flat
        app
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <v-toolbar-title v-if="!showNavigation"
          >ScrapingAnt Admin Panel</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <span class="user-email xs--text fontweight300">{{ user_email }}</span>
      </v-app-bar>
      <v-navigation-drawer
        width="300"
        :permanent="!$vuetify.breakpoint.xsOnly"
        clipped
        v-model="drawer"
        app
        :md-active.sync="showNavigation"
      >
        <template>
          <v-list class="pt-0">
            <v-subheader class="subheader">ScrapingAnt Admin Panel</v-subheader>
            <v-list-item-group color="primary">
              <v-list-item to="/dashboard">
                <v-list-item-icon>
                  <v-icon>mdi-view-dashboard</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/webscrapingapi">
                <v-list-item-icon>
                  <v-icon>mdi-web</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Web Scraping API</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/residential">
                <v-list-item-icon>
                  <v-icon>mdi-account-network</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Residential Proxies</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/datacenter">
                <v-list-item-icon>
                  <v-icon>mdi-server-network</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Datacenter Proxies</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/subscriptions">
                <v-list-item-icon>
                  <v-icon>mdi-shopping</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Subscriptions</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/support">
                <v-list-item-icon>
                  <v-icon>mdi-headphones</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Support</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/transactions">
                <v-list-item-icon>
                  <v-icon>mdi-cart</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Transactions</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/profile">
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Profile</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="open_documentation">
                <v-list-item-icon>
                  <v-icon>mdi-help-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>API Documentation</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="open_proxies_documentation">
                <v-list-item-icon>
                  <v-icon>mdi-help-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Proxies Documentation</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logout">
                <v-list-item-icon>
                  <v-icon>mdi-power</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-navigation-drawer>

      <v-main style="padding-left: 0; padding-top: 16px;">
        <dashboard-content></dashboard-content>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import DashboardContent from "./Content.vue";

export default {
  components: {
    DashboardContent,
  },
  data() {
    return {
      showNavigation: false,
      user_email: "",
      appTitle: "App Prototype",
      drawer: true,
      clipped: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(null, console.log);
    },

    open_documentation() {
      window.open("https://docs.scrapingant.com/", "_blank");
    },

    open_proxies_documentation() {
      window.open("https://proxydocs.scrapingant.com/", "_blank");
    },
  },

  mounted() {
    this.$store.dispatch("auth/get_user").then((res) => {
      this.user_email = res.data.email;
    }, console.log);
  },
};
</script>

<style scoped>
@import "https://fonts.googleapis.com/icon?family=Material+Icons";

.user-email {
  margin-left: auto;
  color: white;
}

.md-app {
  height: 100vh;
}

.md-app-drawer {
  width: 300px;
}

.md-app .md-content.md-theme-default {
  background-color: #f7f7f7;
}

@media (min-width: 600px) {
  .large-hide {
    display: none;
  }
}
</style>
